import type { Component } from 'vue';

type BvIconLoader = () => Promise<{ default: Component }>;

const iconModules = import.meta.glob('../icons/*.vue');

const warnedUnknown = new Set<string>();

const iconModuleKey = (icon: string): string => `../icons/${icon}.vue`;

/** Normalize icon name to kebab filename stem; only `bvi-<name>` is accepted. */
const normalizeBvIconName = (icon: string): string | undefined => {
  const name = icon.trim().toLowerCase();
  if (!name.startsWith('bvi-')) {
    return undefined;
  }
  return name.slice(4);
};

/** Returns the Vite lazy import for `icon/icons/<name>.vue`, or `undefined` if missing. */
export const resolveBvIconImport = (icon: string): BvIconLoader | undefined => {
  const name = normalizeBvIconName(icon);
  if (!name) {
    return undefined;
  }
  return iconModules[iconModuleKey(name)] as BvIconLoader | undefined;
};

export const warnUnknownBvIcon = (icon: string): void => {
  const name = normalizeBvIconName(icon);
  if (!name || warnedUnknown.has(name)) {
    return;
  }
  warnedUnknown.add(name);
  if (import.meta.env.VITE_ENV_NAME !== 'production') {
    // eslint-disable-next-line no-console -- only warn in dev
    console.warn(`[bv-icon] Unknown icon "${icon}" (no matching icons/${name}.vue under icon/).`);
  }
};
